module.exports = __webpack_public_path__ + "6c5bf4b3e6da17a8a53373890ee75c4c.svg";